import React from "react";
import { NavLink } from "react-router-dom"; 
import styled from "styled-components";

const Head = styled.div`
    background: ${({content}) => content.titleBgColor};
    color: ${({content}) => content.titleTextColor};
`;

const HeadNav = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
`;

const HeadNav2 = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
`;

const Headline = styled.div`
    display: flex;
    margin-left: 10px;
    margin-right: 30px;
    padding: 5px;
    font-size: ${({content}) => content};
`;

export function Header({content, smallWindow}) {

    const imgSrc = (content.headerImg && content.headerImg.length>0) ? content.imageMap[content.headerImg] : '/static_content/upload_image.jpg';

    return(
        <Head content={content.styles}>
            <HeadNav>
                <NavLink to="/">
                    <img src={imgSrc} alt={content.businessName} style={{'width': '100%'}}/>
                </NavLink>
                {smallWindow ? <Headline content={'0.75rem'}>{content.headline}</Headline> : <Headline content={'1rem'}>{content.headline}</Headline>}
            </HeadNav>
            
            <div style={{ padding: '5px', background: content.styles.titleBgColor}}><hr color={content.styles.highlightColor}></hr></div>
        </Head>
    )
}

export function Header2({content, smallWindow}) {

    return(
        <Head content={content.styles}>
            <HeadNav2>
                {smallWindow ? <Headline content={'0.75rem'}>{content.headline}</Headline> : <Headline content={'1rem'}>{content.headline}</Headline>}
            </HeadNav2>
            
            <div style={{ padding: '5px', background: content.styles.titleBgColor}}><hr color={content.styles.highlightColor}></hr></div>
        </Head>
    )
}